import React, { Component } from "react";
import { connect } from 'react-redux';
import { Modal, Tabs } from 'antd';

import ApprovalFindUpdate from './ApprovalFindUpdate.js';

const timezone = 'UTC'; //Should be set to the timezone of the server, since amplify is on the cloud it uses UTC
const { TabPane } = Tabs;

class ApprovalFindContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
  }

  render() {
    return (
      <Tabs defaultActiveKey="1">
        <TabPane tab={<p>Resource Collection</p>} key="1">
          <ApprovalFindUpdate
            contextMenuKey={1}
            resourceCollection={this.props.resourceCollection}
          />
        </TabPane>
        <TabPane tab={<p>Resource</p>} key="2">
          <ApprovalFindUpdate contextMenuKey={2} />
        </TabPane>
        <TabPane tab={<p>Branch/Division/Cost Center</p>} key="3">
          <ApprovalFindUpdate contextMenuKey={3} />
        </TabPane>
        <TabPane tab={<p>Cost Object</p>} key="4">
          <ApprovalFindUpdate contextMenuKey={4} />
        </TabPane>
      </Tabs>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalFindContainer);